export const FREE_FEATURES = ["Baseball default plays", "Tap-to-hit field and animations", "Plain-English explanations"];

export const TEAM_FEATURES = [
  "Up to 20 players per team",
  "Softball plays",
  "Custom team playbooks",
  "Join links for players and parents",
  "Practice mode, leaderboard and coach drills",
  "PDF export and printable wristbands",
];
